export const Tier1ActiveCollectibles = [
    ['The Bible', '33'],
    ['The Necronomicon', '35'],
    ['Mr. Boom', '37'],
    ['Mom\'s Bra', '39'],
    ['Bob\'s Rotten Head', '42'],
    ['Yum Heart', '45'],
    ['Doctor\'s Remote', '47'],
    ['Lemon Mishap', '56'],
    ['Anarchist Cookbook', '65'],
    ['The Hourglass', '66'],
    ['My Little Unicorn', '77'],
    ['Monstro\'s Tooth', '86'],
    ['Mom\'s Bottle of Pills', '102'],
    ['Monster Manual', '123'],
    ['Dead Sea Scrolls', '124'],
    ['IV Bag', '135'],
    ['Best Friend', '136'],
    ['Remote Detonator', '137'],
    ['Notched Axe', '147'],
    ['Spider Butt', '171'],
    ['Dad\'s Key', '175'],
    ['Telepathy for Dummies', '192'],
    ['How to Jump', '282'],
    ['Box of Spiders', '288'],
    ['Flush!', '291'],
    ['Butter Bean', '294'],
    ['Magic Fingers', '295'],
    ['Unicorn Stump', '298'],
    ['Scissors', '325'],
    ['Wooden Nickel', '349'],
    ['Mega Bean', '351'],
    ['Glass Cannon', '352'],
    ['Box of Friends', '357'],
    ['Tear Detonator', '383'],
    ['D12', '386'],
    ['Ventricle Razor', '396'],
    ['Kidney Bean', '421'],
    ['Mine Crafter', '427'],
    ['D7', '437'],
    ['Pause', '478'],
    ['Wait What?', '484'],
    ['Crooked Penny', '485'],
    ['Dull Razor', '486'],
    ['Metronome', '488'],
    ['Delirious', '510'],
    ['Black Hole', '512'],
    ['Telekinesis', '522'],
    ['Moving Box', '523'],
    ['Golden Razor', '555'],
    ['Free Lemonade', '578'],
    ['Wavy Cap', '582'],
    ['Sharp Key', '623'],
    ['Meat Cleaver', '631'],
    ['Stitches', '635'],
    ['Spin to Win', '655'],
];